import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";

import { Link, Tooltip } from "@mui/material";

import { TwoLineCell } from "../two-line-cell";

/**
 * Component for displaying product variant name with SKU.
 * This is a specialized wrapper around TwoLineCell for product variants.
 *
 * When `linkToStock` is set, the SKU becomes a link to the warehouse stock page
 * (opened in a new tab so the current transaction stays put). Enable it on
 * read-only transaction detail pages — not on forms/dialogs, where navigating
 * away would discard in-progress input.
 */
export const ProductVariantNameCell = ({
  name,
  sku,
  linkToStock = false,
  warehouseId = null,
  warehouseName = null,
}) => {
  let secondary = sku;

  if (sku && linkToStock) {
    const params = new URLSearchParams({ sku });
    if (name) params.set("productVariantName", name);
    // When the caller knows the transaction's warehouse, pre-filter the stock
    // page to it; otherwise the link shows the SKU across all warehouses.
    if (warehouseId) {
      params.set("warehouseId", warehouseId);
      if (warehouseName) params.set("warehouseName", warehouseName);
    }

    secondary = (
      <Tooltip title="Lihat stok gudang">
        <Link
          component={RouterLink}
          to={`/inventory/warehouse-stocks?${params.toString()}`}
          target="_blank"
          rel="noopener"
          underline="hover"
          color="primary"
          onClick={(event) => event.stopPropagation()}
        >
          {sku}
        </Link>
      </Tooltip>
    );
  }

  return <TwoLineCell primary={name} secondary={secondary} />;
};

ProductVariantNameCell.propTypes = {
  name: PropTypes.string.isRequired,
  sku: PropTypes.string,
  linkToStock: PropTypes.bool,
  warehouseId: PropTypes.string,
  warehouseName: PropTypes.string,
};
